import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Sidebar } from '@/components/dashboard/Sidebar';
import { MobileNav } from '@/components/dashboard/MobileNav';
import { DashboardHome } from '@/components/dashboard/DashboardHome';
import { BankingSection } from '@/components/dashboard/BankingSection';
import { EasyLoansSection } from '@/components/dashboard/EasyLoansSection';
import { InsuranceSection } from '@/components/dashboard/InsuranceSection';
import { MedicalSection } from '@/components/dashboard/MedicalSection';
import { LoyaltySection } from '@/components/dashboard/LoyaltySection';
import { EducationSection } from '@/components/dashboard/EducationSection';
import { MarketplaceSection } from '@/components/dashboard/MarketplaceSection';
import { BettingSection } from '@/components/dashboard/BettingSection';
import { SettingsSection } from '@/components/dashboard/SettingsSection';
import { KYCSection } from '@/components/dashboard/KYCSection';

import { TravelSection } from '@/components/dashboard/TravelSection';

export const DashboardPage = () => {
  const { user } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  // Close sidebar on route change (mobile)
  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-raoul-black" data-testid="dashboard-page">
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      
      {/* Main content */}
      <main className="lg:ml-64 min-h-screen pb-20 lg:pb-0">
        <div className="p-4 md:p-6 lg:p-8">
          <Routes>
            <Route index element={<DashboardHome onMenuClick={() => setSidebarOpen(true)} />} />
            <Route path="banking/*" element={<BankingSection />} />
            <Route path="easy-loans" element={<EasyLoansSection />} />
            <Route path="insurance" element={<InsuranceSection />} />
            <Route path="medical" element={<MedicalSection />} />
            <Route path="loyalty" element={<LoyaltySection />} />
            <Route path="education" element={<EducationSection />} />
            <Route path="marketplace" element={<MarketplaceSection />} />
            <Route path="travel" element={<TravelSection />} />
            <Route path="betting" element={<BettingSection />} />
            <Route path="settings" element={<SettingsSection />} />
            <Route path="kyc" element={<KYCSection />} />
          </Routes>
        </div>
      </main>

      {/* Mobile Navigation */}
      <MobileNav />
    </div>
  );
};
